import { getCookielessBaseUrl } from "@glamcorner/core-cf-lib/lib/client/Hosting";

// __webpack_public_path__ is a special variable defines where webpack chucks will be downloaded from
// It needs to be set before any other code runs and tries to import modules
// https://webpack.js.org/guides/public-path/

// @ts-ignore
__webpack_public_path__ = getCookielessBaseUrl();
